import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      <div className="max-w-4xl mx-auto  rounded-lg p-8 mt-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions d'Utilisation</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptation des conditions</h2>
            <p className="text-gray-700 mb-4">
              En accédant et en utilisant Jobrise, vous acceptez d'être lié par ces Conditions d'Utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Description du service</h2>
            <p className="text-gray-700 mb-4">
              Jobrise est une plateforme de recrutement qui permet aux entreprises et recruteurs de :
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Gérer leurs processus de recrutement</li>
              <li>Communiquer avec les candidats via e-mail</li>
              <li>Organiser et suivre les candidatures</li>
              <li>Automatiser certaines tâches de recrutement</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Conditions d'utilisation de l'intégration Gmail</h2>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
              <p className="text-blue-800 font-medium">
                Section spéciale concernant la messagerie intégrée Gmail
              </p>
            </div>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.1 Autorisation et authentification</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Vous autorisez Jobrise à accéder à votre compte Gmail pour lire et envoyer des e-mails en votre nom</li>
              <li>Cette autorisation inclut la lecture des e-mails liés à vos activités de recrutement</li>
              <li>L'accès se fait via OAuth 2.0 de Google, un protocole sécurisé et standard</li>
              <li>Vous pouvez révoquer cette autorisation à tout moment dans vos paramètres Google</li>
              <li>Aucun mot de passe Gmail n'est stocké par Jobrise</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.2 Scope d'accès et utilisation</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li><strong>Lecture d'e-mails :</strong> Jobrise accède aux e-mails échangés dans le cadre de vos activités de recrutement</li>
              <li><strong>Envoi d'e-mails :</strong> Jobrise peut envoyer des e-mails depuis votre compte Gmail aux candidats</li>
              <li><strong>Synchronisation :</strong> Les conversations sont synchronisées pour affichage dans notre interface</li>
              <li><strong>Organisation :</strong> Les e-mails sont automatiquement organisés par candidat et poste</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.3 Utilisation responsable</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Vous vous engagez à utiliser la messagerie intégrée uniquement à des fins professionnelles de recrutement</li>
              <li>Vous ne devez pas envoyer de spam, de contenu illégal, harcelant ou inapproprié</li>
              <li>Vous respectez les lois anti-spam (RGPD, CAN-SPAM Act, etc.) et les réglementations sur la protection des données</li>
              <li>Vous obtenez le consentement approprié des destinataires avant de les contacter</li>
              <li>Vous vous assurez que vos communications respectent les standards professionnels</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.4 Traitement des données et confidentialité</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Jobrise traite les e-mails uniquement dans le cadre de la fourniture du service de messagerie</li>
              <li>Les données sont stockées de manière sécurisée et ne sont pas partagées avec des tiers</li>
              <li>Vous conservez la propriété de vos e-mails et conversations</li>
              <li>Jobrise s'engage à ne pas utiliser le contenu de vos e-mails à des fins publicitaires</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">3.5 Limitations et responsabilités</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Jobrise accède uniquement aux e-mails liés à vos activités de recrutement</li>
              <li>Nous ne sommes pas responsables des quotas Gmail ou des limitations imposées par Google</li>
              <li>En cas de suspension de votre compte Gmail par Google, Jobrise n'en sera pas tenu responsable</li>
              <li>Vous êtes responsable du contenu des e-mails que vous envoyez via notre plateforme</li>
              <li>Jobrise peut suspendre l'accès à la messagerie en cas d'utilisation abusive</li>
            </ul>

            <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mb-4">
              <p className="text-amber-800">
                <strong>Avertissement :</strong> L'intégration Gmail nécessite des permissions étendues pour fonctionner correctement.
                Ces permissions sont utilisées exclusivement pour améliorer votre expérience de recrutement et ne seront jamais
                utilisées à des fins non autorisées.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Comptes utilisateur</h2>
            <h3 className="text-xl font-medium text-gray-700 mb-3">4.1 Création de compte</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Vous devez fournir des informations exactes et complètes</li>
              <li>Vous êtes responsable de la sécurité de votre compte</li>
              <li>Un compte par utilisateur est autorisé</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-700 mb-3">4.2 Responsabilités de l'utilisateur</h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Maintenir la confidentialité de vos identifiants</li>
              <li>Nous notifier immédiatement de toute utilisation non autorisée</li>
              <li>Être responsable de toutes les activités sous votre compte</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Utilisation acceptable</h2>
            <p className="text-gray-700 mb-4">Vous vous engagez à ne pas :</p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Utiliser le service à des fins illégales ou non autorisées</li>
              <li>Perturber ou compromettre la sécurité du service</li>
              <li>Tenter d'accéder aux comptes d'autres utilisateurs</li>
              <li>Envoyer du contenu malveillant, diffamatoire ou harcelant</li>
              <li>Violer les droits de propriété intellectuelle</li>
              <li>Utiliser des robots ou scripts automatisés non autorisés</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Propriété intellectuelle</h2>
            <p className="text-gray-700 mb-4">
              Jobrise et ses licenciés possèdent tous les droits de propriété intellectuelle relatifs au service. Vous conservez vos droits sur le contenu que vous créez et partagez via la plateforme.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Confidentialité</h2>
            <p className="text-gray-700 mb-4">
              Votre vie privée est importante. Consultez notre
              <a href="/privacy-policy" className="text-blue-600 hover:text-blue-800 underline"> Politique de Confidentialité</a>
              pour comprendre comment nous collectons, utilisons et protégeons vos informations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Abonnements et paiements</h2>
            <h3 className="text-xl font-medium text-gray-700 mb-3">8.1 Frais</h3>
            <p className="text-gray-700 mb-4">
              Certaines fonctionnalités peuvent être payantes. Les prix sont indiqués clairement avant tout engagement.
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-3">8.2 Remboursements</h3>
            <p className="text-gray-700 mb-4">
              Les remboursements sont traités selon notre politique de remboursement, disponible sur demande.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Limitation de responsabilité</h2>
            <p className="text-gray-700 mb-4">
              Jobrise est fourni "en l'état". Nous déclinons toute responsabilité pour :
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>Les dommages indirects, incidents ou consécutifs</li>
              <li>La perte de données ou de profits</li>
              <li>L'interruption de service</li>
              <li>Les actions de tiers utilisant nos services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Résiliation</h2>
            <h3 className="text-xl font-medium text-gray-700 mb-3">10.1 Résiliation par l'utilisateur</h3>
            <p className="text-gray-700 mb-4">
              Vous pouvez résilier votre compte à tout moment en nous contactant ou via les paramètres de votre compte.
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-3">10.2 Résiliation par Jobrise</h3>
            <p className="text-gray-700 mb-4">
              Nous pouvons suspendre ou résilier votre compte en cas de violation de ces conditions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Modifications des conditions</h2>
            <p className="text-gray-700 mb-4">
              Nous nous réservons le droit de modifier ces conditions. Les modifications importantes vous seront notifiées par e-mail ou via la plateforme.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Droit applicable</h2>
            <p className="text-gray-700 mb-4">
              Ces conditions sont régies par le droit français. Tout litige sera soumis aux tribunaux compétents de France.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Contact</h2>
            <p className="text-gray-700 mb-4">
              Pour toute question concernant ces conditions d'utilisation, contactez-nous :
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700">
                <strong>E-mail :</strong> florian@jobrise.tech<br/>
                <strong>Adresse :</strong> Paris<br/>
                <strong>Téléphone :</strong> +33 (0)7 54 81 52 61
              </p>
            </div>
          </section>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-8">
            <p className="text-yellow-800">
              <strong>Important :</strong> En utilisant Jobrise, vous reconnaissez avoir lu, compris et accepté ces conditions d'utilisation ainsi que notre politique de confidentialité.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;